"use strict";exports.__esModule = true;exports.keyListener = void 0;var _globalObject = require("@skbkontur/global-object");

var _identifiers = require("./keyboard/identifiers");var

KeyListener =


function KeyListener() {var _this = this;this.isTabPressed = false;this.isArrowPressed = false;
  _globalObject.globalObject.addEventListener == null || _globalObject.globalObject.addEventListener('keydown', function (e) {
    _this.isTabPressed = (0, _identifiers.isKeyTab)(e);
    _this.isArrowPressed = (0, _identifiers.isKeyArrow)(e);
  });
  _globalObject.globalObject.addEventListener == null || _globalObject.globalObject.addEventListener('mousedown', function () {
    _this.isTabPressed = false;
    _this.isArrowPressed = false;
  });
};


var keyListener = exports.keyListener = new KeyListener();